import CardFees from '@/model/CardFees';
import { CardFeesInstallment } from '@/model/CardFeesInstallment';

export const getMaximumInstallment = (fees: CardFees): number =>
  Math.max(0, ...fees.installmentFees.map(item => Number(item.installment)));

export const getSharedInstallmentFees = (cardFees: CardFees[]): CardFeesInstallment[] => {
  if (cardFees.length === 0) {
    return [];
  }

  return cardFees[0].installmentFees
    .filter(item =>
      cardFees.every(fees =>
        fees.installmentFees.some(
          configured => Number(configured.installment) === Number(item.installment),
        ),
      ),
    )
    .map(item => ({
      installment: Number(item.installment),
      fee: Math.max(
        ...cardFees.map(fees => {
          const configured = fees.installmentFees.find(
            data => Number(data.installment) === Number(item.installment),
          );
          return Number(configured?.fee);
        }),
      ),
    }))
    .sort((first, second) => first.installment - second.installment);
};

export const calculateCreditCardPaymentValue = (
  baseValue: number,
  creditFee: number,
  installmentFee: number,
  installments: number,
): number => {
  const creditFactor = Number(creditFee) / 100 + 1;
  let value = Number(baseValue) * creditFactor;

  if (Number(installments) > 1) {
    value = value * creditFactor * (1 + Number(installmentFee) / 100) ** (Number(installments) - 1);
  }

  return value;
};
